export default __webpack_public_path__ + "static/media/pImg1.eaa96ae4.jpg";